import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/documents/$id')({
  component: DocumentViewerPage,
})

function DocumentViewerPage() {
  const { id } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Document Viewer
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                Viewing document details and PDF with signature fields
              </p>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                Document ID:
              </p>
              <code className="text-lg font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100">
                {id}
              </code>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Features (To be implemented)
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400">
                <li>PDF viewer with signature field overlays</li>
                <li>Document metadata and status</li>
                <li>Signer information and progress</li>
                <li>Signature placement tools</li>
                <li>Download and print options</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
